import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const spinnerVariants = cva(
  "inline-block rounded-full border-[1.5px] border-t-transparent animate-spin shrink-0",
  {
    variants: {
      size: {
        sm: "w-3 h-3",
        md: "w-4 h-4",
        lg: "w-5 h-5",
      },
      tone: {
        default: "border-fg-3",
        accent: "border-accent",
        muted: "border-fg-4",
      },
    },
    defaultVariants: {
      size: "md",
      tone: "default",
    },
  },
);

export type SpinnerProps = VariantProps<typeof spinnerVariants> & {
  className?: string;
};

export function Spinner({
  size = "md",
  tone = "default",
  className,
}: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn(spinnerVariants({ size, tone }), className)}
    />
  );
}
